var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.guideController.selectedCard)?_c('v-textarea',{staticClass:"ma-2",attrs:{"placeholder":"Here goes the speaker's notes","readonly":_vm.readonly},model:{value:(_vm.guideController.selectedCard.notes),callback:function ($$v) {_vm.$set(_vm.guideController.selectedCard, "notes", $$v)},expression:"guideController.selectedCard.notes"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }